// Public metadata: browser title, meta description and share image, per page and per language.
// Titles follow "Page | Consultants Sparks", except the homepage which leads with the brand.
export const BRAND = "Consultants Sparks";
export const CANONICAL_HOST = "https://consultantsparks.com";

export const OG_IMAGES = {
  brand: {
    url: `${CANONICAL_HOST}/og/consultants-sparks-og-v1.jpg`,
    byLang: {
      fr: `${CANONICAL_HOST}/og/consultants-sparks-og-v1.jpg`,
      en: `${CANONICAL_HOST}/og/consultants-sparks-og-en-v1.jpg`,
      es: `${CANONICAL_HOST}/og/consultants-sparks-og-es-v1.jpg`,
    },
    width: 1200,
    height: 630,
    alt: {
      fr: "Consultants Sparks — Projets. Humains. Croissance.",
      en: "Consultants Sparks — Projects. People. Growth.",
      es: "Consultants Sparks — Proyectos. Personas. Crecimiento.",
    },
  },
  people: {
    url: `${CANONICAL_HOST}/og/consultants-sparks-people-og-v1.jpg`,
    byLang: {
      fr: `${CANONICAL_HOST}/og/consultants-sparks-people-og-v1.jpg`,
      en: `${CANONICAL_HOST}/og/consultants-sparks-people-og-en-v1.jpg`,
      es: `${CANONICAL_HOST}/og/consultants-sparks-people-og-es-v1.jpg`,
    },
    width: 1200,
    height: 630,
    alt: {
      fr: "Consultants Sparks — Développement humain",
      en: "Consultants Sparks — Human development",
      es: "Consultants Sparks — Desarrollo humano",
    },
  },
};

export const OG_LOCALES = { fr: "fr_CA", en: "en_CA", es: "es_ES" };

export const PAGE_META = {
  home: {
    image: "brand",
    fr: {
      title: "Consultants Sparks | Projets. Humains. Croissance.",
      description:
        "Consultants Sparks développe des projets, des personnes, des équipes et des opportunités de croissance.",
    },
    en: {
      title: "Consultants Sparks | Projects. People. Growth.",
      description: "Consultants Sparks develops projects, people, teams and growth opportunities.",
    },
    es: {
      title: "Consultants Sparks | Proyectos. Personas. Crecimiento.",
      description:
        "Consultants Sparks desarrolla proyectos, personas, equipos y oportunidades de crecimiento.",
    },
  },
  about: {
    image: "brand",
    fr: {
      title: "À propos | Consultants Sparks",
      description:
        "Une organisation qui développe des projets et des personnes, avec rigueur, confidentialité et progression.",
    },
    en: {
      title: "About | Consultants Sparks",
      description:
        "An organization that develops projects and people, with rigour, confidentiality and progression.",
    },
    es: {
      title: "Quiénes somos | Consultants Sparks",
      description:
        "Una organización que desarrolla proyectos y personas, con rigor, confidencialidad y progresión.",
    },
  },
  opportunities: {
    image: "brand",
    fr: {
      title: "Opportunités | Consultants Sparks",
      description:
        "Explorez les grandes catégories d'opportunités : immobilier, assurance et services financiers, vente, campagnes, développement des affaires et leadership.",
    },
    en: {
      title: "Opportunities | Consultants Sparks",
      description:
        "Explore the main categories of opportunities: real estate, insurance and financial services, sales, campaigns, business development and leadership.",
    },
    es: {
      title: "Oportunidades | Consultants Sparks",
      description:
        "Explore las principales categorías de oportunidades: inmobiliario, seguros y servicios financieros, ventas, campañas, desarrollo de negocios y liderazgo.",
    },
  },
  realEstate: {
    image: "brand",
    fr: {
      title: "Immobilier | Consultants Sparks",
      description:
        "Développer des talents, des équipes et des projets immobiliers : carrières, réseaux, équipes de vente et partenariats.",
    },
    en: {
      title: "Real estate | Consultants Sparks",
      description:
        "Developing real estate talent, teams and projects: careers, networks, sales teams and partnerships.",
    },
    es: {
      title: "Inmobiliario | Consultants Sparks",
      description:
        "Desarrollar talento, equipos y proyectos inmobiliarios: carreras, redes, equipos de ventas y alianzas.",
    },
  },
  careers: {
    image: "people",
    fr: {
      title: "Offres d'emploi vente — Agent des ventes | Consultants Sparks",
      description:
        "Offres d'emploi dans la vente chez Consultants Sparks : agent/agente des ventes, représentant des ventes en magasin (Québec). Postulez directement en ligne, CV facultatif.",
    },
    en: {
      title: "Sales jobs — Sales agent | Consultants Sparks",
      description:
        "Sales jobs at Consultants Sparks: sales agent, in-store sales representative (Québec). Apply directly online, CV optional.",
    },
    es: {
      title: "Ofertas de empleo en ventas — Agente de ventas | Consultants Sparks",
      description:
        "Ofertas de empleo en ventas en Consultants Sparks: agente de ventas, representante de ventas en tienda (Quebec). Postule directamente en línea, CV opcional.",
    },
  },
  humanDev: {
    image: "people",
    fr: {
      title: "Développement humain | Consultants Sparks",
      description:
        "Une organisation grandit lorsque les personnes qui la composent grandissent : accompagnement, formation et leadership.",
    },
    en: {
      title: "Human development | Consultants Sparks",
      description:
        "An organization grows when its people grow: mentoring, training and leadership development.",
    },
    es: {
      title: "Desarrollo humano | Consultants Sparks",
      description:
        "Una organización crece cuando crecen sus personas: acompañamiento, formación y liderazgo.",
    },
  },
  projects: {
    image: "brand",
    fr: {
      title: "Projets | Consultants Sparks",
      description:
        "Transformer les opportunités en initiatives structurées et durables, du cadrage au déploiement.",
    },
    en: {
      title: "Projects | Consultants Sparks",
      description:
        "Turning opportunities into structured, sustainable initiatives, from framing to deployment.",
    },
    es: {
      title: "Proyectos | Consultants Sparks",
      description:
        "Convertir oportunidades en iniciativas estructuradas y sostenibles, del encuadre al despliegue.",
    },
  },
  contact: {
    image: "brand",
    fr: {
      title: "Nous joindre | Consultants Sparks",
      description:
        "Écrivez-nous pour discuter d'un projet, d'un parcours professionnel ou d'un partenariat. Québec, Canada.",
    },
    en: {
      title: "Contact | Consultants Sparks",
      description:
        "Get in touch to discuss a project, a professional path or a partnership. Québec, Canada.",
    },
    es: {
      title: "Contacto | Consultants Sparks",
      description:
        "Escríbanos para hablar de un proyecto, una trayectoria profesional o una alianza. Québec, Canadá.",
    },
  },
  apply: {
    image: "people",
    fr: {
      title: "Soumettre ma candidature | Consultants Sparks",
      description:
        "Déposez votre candidature générale : trois étapes simples, CV facultatif, consentements clairs et distincts.",
    },
    en: {
      title: "Submit my application | Consultants Sparks",
      description:
        "Submit your general application: three simple steps, optional CV, clear and separate consents.",
    },
    es: {
      title: "Enviar mi candidatura | Consultants Sparks",
      description:
        "Envíe su candidatura general: tres pasos sencillos, CV opcional, consentimientos claros y distintos.",
    },
  },
  join: {
    image: "people",
    fr: {
      title: "Rejoindre Consultants Sparks | Opportunités et développement",
      description:
        "Découvrez les possibilités de développement, de vente, de leadership et de projets chez Consultants Sparks. Trois étapes, CV facultatif.",
    },
    en: {
      title: "Join Consultants Sparks | Opportunities and development",
      description:
        "Discover development, sales, leadership and project possibilities at Consultants Sparks. Three steps, CV optional.",
    },
    es: {
      title: "Únase a Consultants Sparks | Oportunidades y desarrollo",
      description:
        "Descubra las posibilidades de desarrollo, ventas, liderazgo y proyectos en Consultants Sparks. Tres pasos, CV opcional.",
    },
  },
  privacy: {
    image: "brand",
    fr: {
      title: "Politique de confidentialité | Consultants Sparks",
      description:
        "Quels renseignements Consultants Sparks recueille, pourquoi, comment ils sont utilisés et quels sont vos droits.",
    },
    en: {
      title: "Privacy policy | Consultants Sparks",
      description:
        "What information Consultants Sparks collects, why, how it is used and what your rights are.",
    },
    es: {
      title: "Política de privacidad | Consultants Sparks",
      description:
        "Qué información recopila Consultants Sparks, por qué, cómo se utiliza y cuáles son sus derechos.",
    },
  },
  terms: {
    image: "brand",
    fr: {
      title: "Conditions d'utilisation | Consultants Sparks",
      description:
        "Les conditions d'utilisation de la plateforme Consultants Sparks et les engagements qui s'y rattachent.",
    },
    en: {
      title: "Terms of use | Consultants Sparks",
      description:
        "The terms of use of the Consultants Sparks platform and the commitments attached to them.",
    },
    es: {
      title: "Términos de uso | Consultants Sparks",
      description:
        "Los términos de uso de la plataforma Consultants Sparks y los compromisos asociados.",
    },
  },
};

export function pageMeta(key, lang) {
  const entry = PAGE_META[key] || PAGE_META.home;
  const copy = entry[lang] || entry.fr;
  const image = OG_IMAGES[entry.image] || OG_IMAGES.brand;
  return {
    ...copy,
    image: { ...image, url: image.byLang[lang] || image.url },
    imageAlt: image.alt[lang] || image.alt.fr,
  };
}
